<template>
  <v-container :class="sectionClass">
    <h1>Program Kami</h1>
  </v-container>
</template>
<script>
import LayoutHome from '@layouts/Home.vue'
export default {
  name: 'Program',
  layout: LayoutHome,
}
</script>
